export const es_dateFormat = 'D/M/YYYY'
